"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var UnderValidationMessage = function UnderValidationMessage(_ref) {
  var websiteUrl = _ref.websiteUrl,
    linkColor = _ref.linkColor;
  return _react["default"].createElement("div", null, _react["default"].createElement("p", {
    style: {
      color: 'black',
      fontSize: '1.7em',
      fontWeight: 600,
      lineHeight: '2em'
    }
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.flywire.payment.underValidation.title"
  })), _react["default"].createElement("p", null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.flywire.payment.underValidation.descriptionOne"
  })), _react["default"].createElement("p", null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.flywire.payment.underValidation.descriptionTwo"
  })), _react["default"].createElement("p", null, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.flywire.payment.underValidation.contactus.description"
  }), _react["default"].createElement("a", {
    href: "".concat(websiteUrl, "/contact"),
    style: {
      color: linkColor,
      fontWeight: 600
    }
  }, _react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "htmPayment.flywire.payment.underValidation.contactus.link"
  }))));
};
var _default = exports["default"] = UnderValidationMessage;